export const getStyles = (theme: any, isResponseMessage: boolean) => ({
  styles: {
    wrapper: {
      marginLeft: isResponseMessage ? "auto" : "initial",
      minWidth: "50%",
      width: '50%',
    },
    content: {
      backgroundColor: isResponseMessage
        ? theme.palette.grey[900]
        : theme.palette.grey[400],
      height: "auto",
      borderRadius: "0px 16px 16px 16px",
      marginBottom: "24px",
      padding: isResponseMessage ? "24px" : "24px 24px",
      wordBreak: 'break-word' as 'break-word',
    },
    texts: {
      alignItems: "center",
      display: isResponseMessage ? "flex" : "block",
      marginTop: isResponseMessage ? '20px' : '0',
      justifyContent: "space-between",
      flexDirection: "row-reverse" as "row-reverse",
    },
    header: {
      alignItems: "center",
      display: "flex",
      marginBottom: isResponseMessage ? "0" : "20px",
      justifyContent: "space-between",
      color: isResponseMessage ? theme.palette.grey[0] : theme.palette.grey[900],
      wordWrap: "break-word" as "break-word",
    },
    text: {
      alignItems: "center",
      display: "flex",
      justifyContent: "space-between",
      color: isResponseMessage ? theme.palette.grey[0] : theme.palette.grey[900],
    },
    icon: {
      width: "40px",
      height: "40px",
      marginLeft: "12px",
      backgroundColor: 'transparent',
    },
  },
});
